import WidthrawLeadModal from './WidthrawLeadModal.component';

export default WidthrawLeadModal;